module.exports = __webpack_public_path__ + "img/km.4a12bb17.svg";